import ProductFilterBase, {
  IProductFilterGroup,
} from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import ProductFilterMultiSelect from '@dh-io-emh/shared/src/models/product-filter/product-filter-multi-select.model';
import { MultiselectGroupOption } from '@dh-io-emh/ui/src/form/multiselectGroup/MultiselectGroup.model';
import { computed, reactive, Ref, ref } from 'vue';
import { mapMultiselectFilterOptions } from '../utils/helpers';
import { useFilterOptions } from './filter-options.composable';

export type MultiselectFilterCategory = {
  name: string;
  code: string;
  options: MultiselectGroupOption[];
  handleChange: (option: MultiselectGroupOption) => void;
};

export const getSelectedCategoryFilterCounter = (filter: ProductFilterBase) => {
  if (!filter.options) {
    return filter.isSelected() ? filter.value.length : 0;
  }

  return filter.options.filter((option) => option.selected).length;
};

export const useMultiselectFilterCategories = ({
  emit,
  exclude,
  filterCategory,
  optionMappingFn,
}: {
  emit: (event: 'change', ...args: any[]) => void;
  exclude?: { key: string; value: any }[];
  filterCategory: Ref<IProductFilterGroup>;
  optionMappingFn?: (option: MultiselectGroupOption, filter: ProductFilterBase) => MultiselectGroupOption;
}) =>
  computed<MultiselectFilterCategory[]>(() =>
    filterCategory.value.filters.map((filter) => {
      const filterRef = ref<ProductFilterMultiSelect>(filter as ProductFilterMultiSelect);

      const { filterOptions, toggleOption } = useFilterOptions({
        filter: filterRef,
        emit,
        exclude,
      });

      const options = mapMultiselectFilterOptions({ filter: filterRef.value, options: filterOptions.value }) || [];

      return reactive<MultiselectFilterCategory>({
        name: filter.name,
        code: filter.code,
        options: optionMappingFn ? options.map((option) => optionMappingFn(option, filter)) : options,
        handleChange: ({ value }: MultiselectGroupOption) => {
          toggleOption(value);
        },
      });
    }),
  );
